const LeftPanelOrder = ({filter, filteredRequests, handleFilterChange}) => {
    
    const btnArray = [{name: 'Все вместе', active: 'all'},
    {name: 'Новые', active: 'new'}, 
    {name: 'В работе', active: 'inwork'} , 
    {name: 'Завершенные', active: 'complete'}]
    
    return ( 
        <div className="left-panel__navigation">
            <div className="left-panel__navigation-title">Заявки</div>
            <ul>
                {btnArray.map((btn) => (
                    <li key={btn.active}>
                        <span data-value={btn.active}
                            data-role="left-status" 
                            className={filter === btn.active ? 'active' : ''}
                            onClick={() => handleFilterChange(btn.active)}>
                            {btn.name}
                            <div className="badge">
                                {filteredRequests[btn.active].length}
                            </div>
                        </span>
                    </li>
                ))}                   
            </ul>
        </div>
     );
}
 
export default LeftPanelOrder;